import { render, staticRenderFns } from "./UpdateDepartment.vue?vue&type=template&id=2a9ba969"
import script from "./UpdateDepartment.vue?vue&type=script&lang=ts"
export * from "./UpdateDepartment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports